(() => {
  const ICONS = [
    'https://cdn.shopify.com/s/files/1/0810/5197/5919/files/soru_seffaf.png?v=1782254054',
    'https://cdn.shopify.com/s/files/1/0810/5197/5919/files/konum_seffaf.png?v=1782254054',
    'https://cdn.shopify.com/s/files/1/0810/5197/5919/files/Telefon_seffaf.png?v=1782254054'
  ];
  const ROTATE_MS = 3000;
  const FLIP_MS = 320;
  let iconIndex = 0;
  let rotationTimer = 0;
  let switchTimer = 0;
  let flipFallbackTimer = 0;
  let mapLoaded = false;

  function init() {
    const mainBtn = document.getElementById('chat-widget-btn');
    const drawer = document.getElementById('chat-drawer');
    const overlay = document.getElementById('chat-drawer-overlay');
    const closeBtn = document.getElementById('close-drawer-btn');
    const iconsContainer = document.getElementById('chat-widget-icons-container');
    const chatIcon = document.getElementById('chat-widget-icon');
    const map = document.querySelector('[data-gb-chat-map]');
    if (!mainBtn || !drawer || !overlay) return;

    const stopRotation = () => {
      window.clearTimeout(rotationTimer);
      rotationTimer = 0;
    };

    const finishFlip = () => {
      window.clearTimeout(flipFallbackTimer);
      flipFallbackTimer = 0;
      iconsContainer?.classList.remove('is-switching');
    };

    const cancelFlip = () => {
      window.clearTimeout(switchTimer);
      window.clearTimeout(flipFallbackTimer);
      switchTimer = 0;
      flipFallbackTimer = 0;
      iconsContainer?.classList.remove('is-switching');
    };

    const rotateIcon = () => {
      if (!iconsContainer || !chatIcon || document.hidden || drawer.classList.contains('active')) return;
      if (iconsContainer.classList.contains('is-switching')) return;

      iconsContainer.classList.add('is-switching');
      window.clearTimeout(switchTimer);
      switchTimer = window.setTimeout(() => {
        iconIndex = (iconIndex + 1) % ICONS.length;
        chatIcon.src = ICONS[iconIndex];
        switchTimer = 0;
      }, Math.round(FLIP_MS / 2));

      iconsContainer.addEventListener('animationend', finishFlip, { once: true });
      window.clearTimeout(flipFallbackTimer);
      flipFallbackTimer = window.setTimeout(finishFlip, FLIP_MS + 80);
    };

    const scheduleRotation = () => {
      stopRotation();
      if (document.hidden || drawer.classList.contains('active')) return;
      rotationTimer = window.setTimeout(() => {
        rotateIcon();
        scheduleRotation();
      }, ROTATE_MS);
    };

    const loadMapOnce = () => {
      if (mapLoaded || !map) return;
      const src = map.dataset.src;
      if (src) {
        map.src = src;
        mapLoaded = true;
      }
    };

    const openDrawer = () => {
      cancelFlip();
      drawer.classList.add('active');
      overlay.classList.add('active');
      drawer.setAttribute('aria-hidden', 'false');
      mainBtn.setAttribute('aria-expanded', 'true');
      stopRotation();
      loadMapOnce();
    };

    const closeDrawer = () => {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
      drawer.setAttribute('aria-hidden', 'true');
      mainBtn.setAttribute('aria-expanded', 'false');
      scheduleRotation();
    };

    const iconCache = ICONS.map((url) => {
      const image = new Image();
      image.decoding = 'async';
      image.src = url;
      return image;
    });
    void iconCache;

    if (chatIcon) chatIcon.src = ICONS[0];
    if (iconsContainer) window.requestAnimationFrame(() => iconsContainer.classList.add('is-ready'));

    mainBtn.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopRotation();
        cancelFlip();
      } else {
        scheduleRotation();
      }
    });

    scheduleRotation();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(() => {
  const DRAWER_KEY = '__gurbakirDrawer';
  const SESSION_KEY = '__gurbakirDrawerSession';
  const session =
    window.__gbDrawerHistorySession ||
    (window.__gbDrawerHistorySession =
      (globalThis.crypto?.randomUUID?.() || `gb-${Date.now()}-${Math.random().toString(36).slice(2)}`));

  let syncing = false;

  function stateObject() {
    return history.state && typeof history.state === 'object' ? history.state : {};
  }

  function activeHistoryDrawer() {
    const state = stateObject();
    return state[SESSION_KEY] === session ? state[DRAWER_KEY] || null : null;
  }

  function clearStaleDrawerState() {
    const state = stateObject();
    if (!state[DRAWER_KEY] || state[SESSION_KEY] === session) return;
    const next = { ...state };
    delete next[DRAWER_KEY];
    delete next[SESSION_KEY];
    history.replaceState(next, '', location.href);
  }

  function setDrawerHistory(name) {
    const state = stateObject();
    const next = { ...state, [DRAWER_KEY]: name, [SESSION_KEY]: session };

    if (activeHistoryDrawer()) {
      history.replaceState(next, '', location.href);
    } else {
      history.pushState(next, '', location.href);
    }
  }

  function listemIsOpen() {
    return document.getElementById('gb-listem-root')?.classList.contains('is-open') === true;
  }

  function chatIsOpen() {
    return document.getElementById('chat-drawer')?.classList.contains('active') === true;
  }

  function clickWithoutHistory(element) {
    if (!element) return;
    syncing = true;
    element.click();
    queueMicrotask(() => {
      syncing = false;
    });
  }

  function openListem() {
    if (listemIsOpen()) return;
    clickWithoutHistory(document.querySelector('[data-gb-listem-open]'));
  }

  function closeListem() {
    if (!listemIsOpen()) return;
    const root = document.getElementById('gb-listem-root');
    clickWithoutHistory(root?.querySelector('.gb-listem__close, [data-gb-listem-close]'));
  }

  function openChat() {
    if (chatIsOpen()) return;
    clickWithoutHistory(document.getElementById('chat-widget-btn'));
  }

  function closeChat() {
    if (!chatIsOpen()) return;
    clickWithoutHistory(document.getElementById('close-drawer-btn'));
  }

  function syncFromHistory() {
    const drawer = activeHistoryDrawer();

    if (drawer === 'listem') {
      closeChat();
      openListem();
      return;
    }

    if (drawer === 'chat') {
      closeListem();
      openChat();
      return;
    }

    closeListem();
    closeChat();
  }

  clearStaleDrawerState();

  document.addEventListener(
    'click',
    (event) => {
      if (syncing) return;
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (!target) return;

      if (target.closest('[data-gb-listem-open]')) {
        if (chatIsOpen()) closeChat();
        setDrawerHistory('listem');
        return;
      }

      if (target.closest('#chat-widget-btn')) {
        if (listemIsOpen()) closeListem();
        setDrawerHistory('chat');
        return;
      }

      if (target.closest('[data-gb-listem-close]') && activeHistoryDrawer() === 'listem') {
        history.back();
        return;
      }

      if (
        (target.closest('#close-drawer-btn') || target.closest('#chat-drawer-overlay')) &&
        activeHistoryDrawer() === 'chat'
      ) {
        history.back();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (syncing || event.key !== 'Escape') return;
      const drawer = activeHistoryDrawer();

      if ((drawer === 'listem' && listemIsOpen()) || (drawer === 'chat' && chatIsOpen())) {
        history.back();
      }
    },
    true
  );

  window.addEventListener('popstate', syncFromHistory);
})();
